function openDrawer() {
  const drawer = document.getElementById('nav-drawer');

  drawer.classList.remove('nav-drawer--closed');
  drawer.classList.add('nav-drawer--opened');

  $('#nav-drawer-closer').show();
  $('#nav-drawer-opener').hide();
}

function closeDrawer() {
  const drawer = document.getElementById('nav-drawer');

  drawer.classList.remove('nav-drawer--opened');
  drawer.classList.add('nav-drawer--closed');

  $('#nav-drawer-closer').hide();
  $('#nav-drawer-opener').show();
}

function openSearch() {
  const nav = document.getElementsByTagName('nav')[0];
  const navList = nav.getElementsByClassName('nav__list')[0];
  const input = navList.getElementsByTagName('input')[0];

  nav.classList.add('nav--search-opened');
  input.focus();
}

function closeSearch() {
  const nav = document.getElementsByTagName('nav')[0];

  nav.classList.remove('nav--search-opened');
}

function submitNavSearchForm(e: SubmitEvent) {
  const form = e.target as HTMLFormElement;
  const input = form.getElementsByTagName('input')[0];
  const query = input.value;

  if (query.toString().length < 3) {
    const group = form.getElementsByClassName('input-group')[0];
    const errorMessage = group.getElementsByClassName(
      'input-group__error-message'
    )[0];

    group.classList.add('input-group--error');
    errorMessage.textContent = 'Zadajte aspoň 3 znaky.';
    e.preventDefault();
  }
}

export function setupNav() {
  document.getElementById('nav-drawer-opener').onclick = openDrawer;
  document.getElementById('nav-drawer-closer').onclick = closeDrawer;
  document.getElementById('nav-search-opener').onclick = openSearch;
  document.getElementById('nav-search-closer').onclick = closeSearch;
  (
    document.querySelectorAll(
      '[data-is-nav-search-form]'
    ) as NodeListOf<HTMLFormElement>
  ).forEach((x) => (x.onsubmit = submitNavSearchForm));
}
